module.exports = "/images/support.svg?6e24ff5938efbb2d6b291a7c94cfe521";